import { useEffect, useState } from "react";
import { config } from "./config.js";
import { getHealth } from "./api.js";

type State =
  | { kind: "loading" }
  | { kind: "ok"; uptime: number }
  | { kind: "error"; message: string };

export function App() {
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    getHealth()
      .then((r) => setState({ kind: "ok", uptime: r.uptime }))
      .catch((e: unknown) =>
        setState({ kind: "error", message: e instanceof Error ? e.message : String(e) }),
      );
  }, []);

  return (
    <main style={{ fontFamily: "system-ui", padding: "2rem", maxWidth: 640 }}>
      <h1>Schedule Assist</h1>
      <p style={{ color: "#666" }}>
        API URL: <code>{config.API_URL}</code>
      </p>
      {state.kind === "loading" && <p>checking api…</p>}
      {state.kind === "ok" && <p>api ok — uptime {state.uptime}s</p>}
      {state.kind === "error" && <p style={{ color: "crimson" }}>api error: {state.message}</p>}
    </main>
  );
}
